module.exports = __webpack_public_path__ + "img/product_mobile1.9afe9fab.jpg";